import LeftArrow from 'assets/LeftArror';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import RenderIf from '@/components/Common/RenderIf';
interface Props {
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  show?: boolean;
  gradientClass?: string;
  className?: string;
  customPrev?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}
const Left: FC<Props> = ({
  onClick,
  show = true,
  className,
  gradientClass,
  customPrev,
}) => {
  return (
    <div
      className={twMerge(
        'absolute lg:-left-0 md:left-0 left-0 top-0 z-10 h-full lg:flex hidden items-center justify-center',
        className,
      )}
    >
      <button className='h-full relative' onClick={customPrev || onClick} aria-label='Next'>
        <RenderIf condition={show}>
          <LeftArrow className='rotate-180 z-10  transition-transform duration-300 ease-in-out cursor-pointer hover:scale-125' />
        </RenderIf>
        <div
          className={twMerge(
            'w-[250px] h-full  absolute top-0 -left-[40px] bg-gradient-to-r from-black/30 to-transparent -z-10',
            gradientClass,
          )}
        />
      </button>
    </div>
  );
};

export default Left;
